<template>
    <p class="text-muted text-center mb-0" >
        <a  class="text-reset">{{`Copyright  ©  2023  ${info.corporate_name}  版权所有`}}</a><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" class="text-reset pl-3 d-block d-md-inline">{{info.filing_info}}</a>
        <a style="margin-left: 30px;">技术支持【百想科技】微信号：ali100x</a>
    </p>
  </template>
  
  <script>
//   import qrCode from '@/assets/qrCode.png'
 
import store from '@/store'
  export default {
    name: 'copyright',
    props: {
       
    },
    mounted(){
        // this.getFriendLinks()  
    },
    computed:{
        info:function(){
            let info = null
            info = this.$store.getters.getWebConfig
            return info

        },
       
    },
    data() {
      return {
      }
    },
      methods: {
        
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  